import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '@core/config/config.service';
import { AuthService } from '@core/guards/auth.service';
import { HttpService } from '@core/http/http.service';
import { AssetModel } from '@core/models/assets/asset.model';
import { AssetTypeModel } from '@core/models/assets/asset-type.model';
import { ImportReportModel } from '@core/models/administration/imports/import-report.model';
import { ReferentialItem } from '../models/shared/referential-item.model';
import { PagingParametersModel } from '../models/shared/paging-parameters.model';
import { PagedResult } from '../models/paged-result.model';
import { AssetSearchCriteriaModel } from '../models/assets/asset-search-criteria.model';

@Injectable({
  providedIn: 'root'
})
export class AssetService extends HttpService {

  constructor(protected http: HttpClient, protected config: ConfigService, protected authService: AuthService) {
    super(http, config, authService, 'assets');
  }

  getAssetById(assetId: number): Observable<AssetModel> {
    return this.invokeGet<AssetModel>(`${assetId}`);
  }

  getAssetsByType(assetsType?: AssetTypeModel[]): Observable<AssetModel[]> {
    if (!assetsType) {
      return this.invokeGet<AssetModel[]>("");
    }
    return this.invokeGet<AssetModel[]>("", { assetsType: assetsType });
  }


  getPagedAssetsByType(assetSearchCriteriaModel: AssetSearchCriteriaModel, sort?: string, order?: string, page?: number, size?: number): Observable<PagedResult<ReferentialItem>> {
    const pagingParameters = new PagingParametersModel(sort, order, page + 1, size);
    const userGroups = this.invokeGet<PagedResult<ReferentialItem>>(`paged-referential`, assetSearchCriteriaModel, pagingParameters);
    return userGroups;
  }

  getAssetsReferential(assetsType?: AssetTypeModel[]): Observable<ReferentialItem[]> {
    return this.invokeGet<ReferentialItem[]>("referential", { assetsType: assetsType });
  }

  createAsset(asset: AssetModel): Observable<any> {
    return this.invokePost(asset, "");
  }

  updateAsset(asset: AssetModel): Observable<any> {
    return this.invokePut(asset, `${asset.Id}`);
  }

  activateAsset(assetId: number): Observable<any> {
    return this.invokePut(null, `${assetId}/activate`);
  }

  deactivateAsset(assetId: number): Observable<any> {
    return this.invokePut(null, `${assetId}/deactivate`);
  }

  importAssets(files: File[]): Observable<ImportReportModel[]> {
    return this.invokeUploadFiles(files, `import`);
  }
}
